import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";

export default function Logo({
  size,
  className,
  src = "/resources/small-icon.svg",
  alt = "Nutriflex Logo",
}: LogoProps) {
  return (
    <img
      src={src}
      alt={alt}
      className={cn(logoVariants({ size, className }), className)}
    />
  );
}

const baseClasses = "rounded-full object-cover";

const logoVariants = cva(baseClasses, {
  variants: {
    size: {
      sm: "w-[3.25rem] h-[3.25rem]",
      base: "w-20 h-20",
      lg: "w-[6.25rem] h-[6.25rem]",
      xl: "w-[12.5rem] h-[12.5rem]",
    },
  },
  defaultVariants: {
    size: "base",
  },
});

export type LogoProps = {
  className?: string;
  alt?: string;
  src?: string;
} & VariantProps<typeof logoVariants>;
export { Logo };
